$(function () {
    // Initialize WOW.js Scrolling Animations
    new WOW().init();

    // Initialise the popups to allow embedded HTML
    $('[data-toggle="popover"]').popover({ html: true });

    // When the 'info' button is clicked show/hide the appropriate popover
    $('a[data-toggle="trigger"]').on("click", function (e) {
        e.preventDefault();
        $(this).closest("div.team-member").children('img[data-toggle="popover"]').popover("toggle");
    });

    // When a popover is displayed hide any other popovers and add the 'active' class to the button
    $('img[data-toggle="popover"]').on("show.bs.popover", function (e) {
        $('[data-toggle="popover"]').filter("[aria-describedby]").popover("hide");

        var teamMemberDiv = $(this).closest("div.team-member");
        teamMemberDiv.find('a[data-toggle="trigger"]').addClass("active");
        teamMemberDiv.find('img').addClass('active');
    });

    // When a popover is hidden remove the 'active' class from the button
    $('img[data-toggle="popover"]').on("hide.bs.popover", function (e) {
        var teamMemberDiv = $(this).closest("div.team-member");
        teamMemberDiv.find('a[data-toggle="trigger"]').removeClass("active");
        teamMemberDiv.find('img').removeClass('active');
    });
});